// File: /src/hooks/useConfirmDialog.js

import { useContext } from 'react';
import { ConfirmDialogContext } from '../contexts/ConfirmDialogContext';

export function useConfirmDialog() {
	const context = useContext(ConfirmDialogContext);

	if (!context) {
		throw new Error(
			'useConfirmDialog must be used within a ConfirmDialogProvider'
		);
	}

	return context;
}
